"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  border-top: 1px solid ", ";\n  padding-bottom: ", ";\n  padding-top: ", ";\n\n  .FooterContent__columnsWrapper {\n    display: table;\n    width: 100%;\n  }\n"], ["\n  border-bottom: 1px solid ", ";\n  border-top: 1px solid ", ";\n  padding-bottom: ", ";\n  padding-top: ", ";\n\n  .FooterContent__columnsWrapper {\n    display: table;\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s300;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s300;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s600;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s500;
});
exports.Wrapper.displayName = 'FooterContentWrapper';
var templateObject_1;
